import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { warmUp } from './warmUp';

export const inputActions = [warmUp];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
